import { Div } from "@tblabs/truffle";
import { BigHeader, SmallHeader } from "../../../../../Components/Utils/SmallHeader";
import { OrderBox } from "./OrderBox";
import { Tasks } from "./Tasks";
import { StepTypeNames } from "../../../../../Steps/Step/StepType";


export class DayTasks extends Div
{
    constructor(title: string, tasks: Tasks[])
    {
        super();
        this.Width(360).BorderRadius(16).Background("#fff").Padding(16);

        this.Append(
            new BigHeader(title).MarginBottom(4).MarginTop(0).Bold().BorderNone().Background("none")
        );

        tasks.filter(t => t.Orders.length > 0).forEach(task =>
        {
            // const stepName = task.Orders[0].CurrentStep?.GetTitleForCustomer() || "---";
            const stepName = StepTypeNames[task.StepType] ?? "---";

            this.Append(
                new SmallHeader(stepName).MarginBottom(4).Bold(),
                ...task.Orders.map(order => new OrderBox(order))
            );
        });
    }
}
